import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import moment from "moment";

import Header from "../../../../Component/NavBar/User/Header/Header";
import Footer from "../../../../Component/NavBar/User/Footer/Footer";
import Axios from "axios";
import { url } from "../../../../config/config";
import { connect } from "react-redux";
import JwtDecode from "jwt-decode";
import CustomTableHead from "../../../../Component/Table/CustomTableHead/CustomTableHead";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import { useStyles } from "./paymentDetails.css";

class PaymentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentDetails: [],
      userData: [],
      column: [
        {
          name: "S.N.",
        },
        {
          name: "Book Title",
        },
        {
          name: "Price",
        },
      ],
      usdCurrency: 0,
    };
  }

  componentDidMount() {
    if (this.props.match.params.paymentUniqueId) {
      this.getPaymentDetails(this.props.match.params.paymentUniqueId);
      this.decodeData(this.props.userToken);
      this.getCurrency();
    }
  }

  getPaymentDetails = async (paymentUniqueId) => {
    const response = await Axios.get(`${url}/api/sold/${paymentUniqueId}`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    if (response.data.length !== 0) {
      this.setState({
        paymentDetails: response.data,
        isEmpty: false,
      });
    } else {
      this.setState({
        paymentDetails: [],
        isEmpty: true,
      });
    }
  };

  decodeData = (userToken) => {
    try {
      const decodedData = JwtDecode(userToken);
      this.setState({
        userData: decodedData,
      });
    } catch (error) {}
  };

  getCurrency = async () => {
    const response = await Axios.get("https://api.exchangerate.host/latest", {
      params: {
        base: "NPR",
      },
    });
    this.setState({
      usdCurrency: response.data.rates.USD,
    });
  };

  render() {
    const { classes } = this.props;
    const { paymentDetails, userData } = this.state;
    return (
      <div>
        <Header />
        <div className={classes.root}>
          <div style={{ fontSize: 30 }}>Payment Details</div>
          <Divider />
          {this.state.paymentDetails.length !== 0 ? (
            <Paper className={classes.paper}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flexGrow: 1, fontSize: 16 }}>
                  <div>Payment Id. {paymentDetails.paymentId}</div>
                  <div>
                    Date: {moment(paymentDetails.createdAt).format("LL")}
                  </div>
                </div>
              </div>
              <br />
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ fontSize: 16, flexGrow: 1 }}>
                  <div>Bill To:</div>
                  <div>
                    {userData.firstName} {userData.middleName}{" "}
                    {userData.lastName}
                  </div>
                  <div>{userData.email}</div>
                </div>
                <div style={{ fontSize: 16 }}>
                  <div>OrderId: {paymentDetails.orderId}</div>
                  <div>Pay Via: {paymentDetails.payVia}</div>
                </div>
              </div>
              <br />
              <Divider className={classes.divider} />
              <br />
              <div>
                <TableContainer>
                  <Table className={classes.tableStyle}>
                    <CustomTableHead column={this.state.column} />

                    <TableBody>
                      {paymentDetails.itemDetails.map((item, index) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor: `${index % 2 ? "#eee" : "white"}`,
                          }}
                        >
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">{item.title}</TableCell>
                          {paymentDetails.payVia === "paypal" ? (
                            <TableCell align="center">
                              ${" "}
                              {Math.round(
                                item.price * this.state.usdCurrency * 100
                              ) / 100}
                            </TableCell>
                          ) : (
                            <TableCell align="center">
                              Rs. {item.price}
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell rowSpan={3} />
                        <TableCell colSpan={1} align="right">
                          Total
                        </TableCell>
                        {paymentDetails.payVia === "paypal" ? (
                          <TableCell align="center">
                            $ {paymentDetails.totalPrice}
                          </TableCell>
                        ) : (
                          <TableCell align="center">
                            Rs. {paymentDetails.totalPrice}
                          </TableCell>
                        )}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Paper>
          ) : this.state.isEmpty === true ? (
            <div>There is no any payment made.</div>
          ) : (
            <CustomLoader />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(PaymentDetails));
